module.exports = __webpack_public_path__ + "img/bg4.515e685d.png";